/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c52972a3b198
 */

import { dlv } from "./dlv.js";

import * as z from "zod";
import { SDKOptions } from "./config.js";

export interface Env {
  CLOUDINARY_API_KEY?: string | undefined;
  CLOUDINARY_API_SECRET?: string | undefined;
  CLOUDINARY_OAUTH2?: string | undefined;

  /**
   * Sets the cloud_name parameter for all supported operations
   */
  CLOUDINARY_CLOUD_NAME?: string | undefined;

  CLOUDINARY_DEBUG?: boolean | undefined;
}

export const envSchema: z.ZodType<Env> = z.object({
  CLOUDINARY_API_KEY: z.string().optional(),
  CLOUDINARY_API_SECRET: z.string().optional(),
  CLOUDINARY_OAUTH2: z.string().optional(),

  CLOUDINARY_CLOUD_NAME: z.string().optional(),

  CLOUDINARY_DEBUG: z.coerce.boolean().optional(),
});

let envMemo: Env | undefined = undefined;
/**
 * Reads and validates environment variables.
 */
export function env(): Env {
  if (envMemo) {
    return envMemo;
  }

  envMemo = envSchema.parse(
    dlv(globalThis, "process.env") ?? dlv(globalThis, "Deno.env") ?? {},
  );
  return envMemo;
}

/**
 * Clears the cached env object. Useful for testing with a fresh environment.
 */
export function resetEnv() {
  envMemo = undefined;
}

/**
 * Populates global parameters with environment variables.
 */
export function fillGlobals(options: SDKOptions): SDKOptions {
  const clone = { ...options };

  const envVars = env();

  if (typeof envVars.CLOUDINARY_CLOUD_NAME !== "undefined") {
    clone.cloud_name ??= envVars.CLOUDINARY_CLOUD_NAME;
  }

  return clone;
}
